import { CheckCircle2 } from 'lucide-react';
import { Button } from '@/components/ui/button';

/**
 * Onboarding wizard tab 5 — Practice Created (PROD-930, epic PROD-856).
 *
 * Final tab. Flutter parity: `practice_created_widget.dart`. Centered
 * layout with a success icon, two lines of copy, and a "Finish Setup"
 * button. The button calls the wizard's `onComplete` prop which —
 * per Flutter `menu_container_screen.dart:451-457` — is purely local:
 * flip `user.isOnboarded = true` in the Zustand auth store and persist
 * via localStorage. No backend write.
 *
 * Wizard shell already hides the Back/Next bar on tab 5 (PR 1's
 * `showShellControls = tabIndex > 0 && tabIndex < 5`), so this tab
 * owns its own controls.
 *
 * Magic strings copied verbatim from Flutter `messages_en.dart`:
 *   - heading: `Your Practice Has Been Created`
 *   - body:    `You can now start filling your profile or explore the app`
 *   - button:  `Finish Setup` (`practice_created_widget.dart:55`)
 */
export interface CompletionStepProps {
  /** Fires the auth-store + localStorage write that flips `isOnboarded` true. */
  onFinish: () => void;
}

export function CompletionStep({ onFinish }: CompletionStepProps) {
  return (
    <div className="flex min-h-[480px] flex-col items-center justify-center px-8 py-16 text-center">
      <CheckCircle2
        className="h-20 w-20 text-[var(--color-status-success)]"
        strokeWidth={1.5}
        aria-hidden
      />
      <h1 className="mt-8 [font:var(--type-card-title)] text-[var(--ink-body)]">
        Your Practice Has Been Created
      </h1>
      <p className="mt-4 max-w-md [font:var(--type-body)] text-[var(--ink-meta)]">
        You can now start filling your profile or explore the app
      </p>
      <Button
        type="button"
        onClick={onFinish}
        className="mt-24 h-12 w-[200px] text-md"
      >
        Finish Setup
      </Button>
    </div>
  );
}
